var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tools") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.7 28-1.1 1.1-4.2-4.2 3.8-3.8 2.7 0.1c2.5 0.1 5-1.2 6.4-3.5l4.7-8.1-3.2-3.2-5.3 5.3-2.8-2.8 5.2-5.3-3.5-3.6-8 5c-2.1 1.3-3.3 3.6-3.3 6.1l0.1 3-4.2 4.2-9.2-9.3-1.1-6.3-9.5-2.4-3 3 2.8 9.1 5.8 1.5 9.2 9.2-16 16.2c-1 1-1.5 2.2-1.5 3.5s0.5 2.5 1.5 3.5 2.2 1.5 3.5 1.5 2.5-0.5 3.5-1.5l16.1-16.1 4.2 4.2-1.3 1.4 10.5 10.4c1.1 1.1 2.4 1.6 3.8 1.6s2.8-0.5 3.8-1.6c1.1-1.1 1.6-2.4 1.6-3.8 0-1.5-0.5-2.9-1.6-3.8l-10.4-10.6zm-25.8-16.1-5.4-1.4-2.2-6.9 1.3-1.3 7.3 1.8 1 5.6 9.8 9.8-2.1 2.1-9.7-9.7zm-2.4 33c-1.2 1.2-3.1 1.2-4.2 0-0.5-0.5-0.8-1.3-0.8-2.1s0.3-1.6 0.8-2.1l16.3-16.3 5-4.9 4.9-4.9-0.1-3.8c-0.1-1.8 0.8-3.4 2.3-4.4l6.7-4.1 1.1 1.1-5.3 5.3 5.6 5.6 5.2-5.3 0.7 0.7-4 6.9c-1 1.6-2.7 2.5-4.6 2.4l-3.5-0.2-4.6 4.5-5.3 5.3-16.2 16.3zm19.1-16.2 2.4-2.4 4.2 4.2-2.4 2.4-4.2-4.2zm18.3 16c-1.4 1.4-3.6 1.4-5 0l-9.1-9 5-5 9.1 9c0.6 0.6 1.1 1.5 1.1 2.4 0 1.1-0.3 2-1.1 2.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.c17343bcf354318e51fc1f01b5deb88f.svg";
export { ForwardRef as ReactComponent };